import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

const SlideInWhenVisible = ({
  children,
  direction = "right",
  delay = 0,
  duration = 0.3,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    amount: 0,
    margin: "-50px 0px -50px 0px",
  });

  const distance = 80;
  const variants = {
    hidden: {
      opacity: 0,
      x:
        direction === "right" ? distance : direction === "left" ? -distance : 0,
      y: direction === "up" ? distance : direction === "down" ? -distance : 0,
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        duration,
        delay,
        ease: [0.25, 0.1, 0.25, 1],
      },
    },
  };

  return (
    <motion.div
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      {children}
    </motion.div>
  );
};

export default SlideInWhenVisible;
